import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import useSelector from '../../../redux/typedHooks';
import { NafBirthday } from './Designs/NafBirthday/NafBirthday';
import { useCloudinary } from '../../../hooks/Cloudinary/useCloudinary';
import { ConstitutionDay } from './Designs/ConstitutionDay/ConstitutionDay';
import * as S from './Logo.styles';

interface LogoProps {
  onNavClick: () => void;
}

export const Logo = ({ onNavClick }: LogoProps) => {
  const { getLogo } = useCloudinary();
  const logo = useSelector((state) => state.globalSettings.settings?.logo);
  const decorationToShow = useSelector((state) => state.globalSettings.settings?.decoration);
  const defaultLogoImage = (logo && logo.publicId && getLogo(logo.publicId)?.toURL()) || undefined;

  let decorationComponent: ReactElement | null;
  switch (decorationToShow) {
    case 'nafBirthday':
      decorationComponent = <NafBirthday />;
      break;
    case 'constitutionDay':
      decorationComponent = <ConstitutionDay />;
      break;
    case 'none':
    default:
      decorationComponent = <S.Logo src={defaultLogoImage} alt="NAF Logo" width={44} height={44} />;
      break;
  }

  return (
    <Link to="/" onClick={onNavClick} aria-label="Til forsiden">
      {decorationComponent}
    </Link>
  );
};
